import styled, {css} from 'styled-components';

import {Switch as BaseSwitch, NewNumberInputField} from '@edna/components';
import {Label} from '@edna/components/FormField';
import {SkeletonItem as BaseSkeletonItem} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {MessagePreview as BaseMessagePreview} from 'src/containers/MessagePreview';

const ITEM_WIDTH = '326px';

export const Name = styled.div`
  width: 100%;
  min-height: 34px;
  padding: 8px 30px;
`;

export const Row = styled.div`
  ${mixins.stack({direction: 'ROW'})};
  gap: 21px;
  overflow: auto;
  ${({theme: {spacing}}) => css`
    padding: 0 ${spacing.s05} ${spacing.s4} ${spacing.s05};
  `}
`;

export const Item = styled.div`
  width: ${ITEM_WIDTH};
  max-width: ${ITEM_WIDTH};
  cursor: pointer;
  overflow: hidden;

  ${({theme}) => css`
    border-radius: ${theme.borderRadius.br3};
    box-shadow: ${theme.boxShadow.XS};
  `};
`;

export const ListTotal = styled.div`
  ${mixins.f6};
  font-weight: 500;
  padding: ${({theme}) => `${theme.spacing.s2} 0 ${theme.spacing.s4}`};
`;

export const SkeletonList = styled.div`
  ${mixins.stack({size: '5', direction: 'ROW'})};
  overflow: auto;
  margin-top: ${({theme}) => theme.spacing.s4};
`;

export const SkeletonItem = styled(BaseSkeletonItem)`
  width: ${ITEM_WIDTH};
  height: 200px;
  border-radius: ${({theme}) => theme.borderRadius.br3};
`;

export const MessagePreviewWrapper = styled.div`
  position: sticky;
  width: 100%;
  ${({theme}) => css`
    top: ${theme.spacing.s4};
    padding: ${theme.spacing.s4};
    border: 1px solid ${theme.palette.grey100};
    border-radius: ${theme.borderRadius.br2};
  `}
`;

export const Switch = styled(BaseSwitch)`
  margin-bottom: ${({theme}) => theme.spacing.s4};
  margin-left: auto;
`;

export const MessagePreview = styled(BaseMessagePreview)<{hasBorder?: boolean}>`
  position: static;
  width: ${ITEM_WIDTH};
  min-width: ${ITEM_WIDTH};
  ${({hasBorder, theme}) =>
    hasBorder &&
    css`
      padding: ${theme.spacing.s4};
      border: 1px solid ${theme.palette.grey100};
      border-radius: ${theme.borderRadius.br2};
    `}
`;

export const SmallLabel = styled(Label)`
  ${mixins.f2};
`;

export const WabaSubjects = styled.div`
  ${mixins.stack({size: '2', direction: 'ROW'})};
  flex-wrap: wrap;
  margin-left: ${({theme}) => theme.spacing.s6};
`;

export const WabaSubject = styled.div<{isActive?: boolean}>`
  ${mixins.f2};
  ${({theme, isActive}) => css`
    padding: ${theme.spacing.s1} ${theme.spacing.s2};
    border: 1px solid ${isActive ? theme.branding.colors.accentA : theme.palette.grey100};
    border-radius: ${theme.borderRadius.br2};
  `}
`;

export const PhoneInputField = styled(NewNumberInputField)`
  input {
    width: 200px;
  }
`;
